import $ from 'jquery';
import ga from 'ga';
import initHeaderFooter from 'core/initHeaderFooter';
import pieCompletion from 'modules/pie-completion';
import trackerOffresRecommandees from 'modules/tracking_offres_reco';
import confirmerCandidature1Clic from 'modules/lightbox_confirmation_candidature';
import 'remodal';
import 'sass/cadremploi-webapp/espace-perso.scss';
import Notification from 'notification';
import getCandidatureTrackingCategory from 'modules/tracking_offres_perf';

function dashboardEspacePerso(configuration) {
  initHeaderFooter(configuration);
  trackerCreationCompteViaSocialConnect(configuration);
  trackingItemsAccesRapide();
  lightboxDeconnexion();
  trackerOffresRecommandees();
  postulerAuxOffresRecommandees(configuration, 'DASHBOARD');
  
  const desktop = $('.desktop-line'),
    mobile = $('.mobile-line'),
    offreCandidatee = $('.js-espace-perso-offre-candidatee'),
    offreMemorisee = $('.js-espace-perso-offre-memorisee'),
    blocOffresCandidatees = $('.js-offres-candidatees'),
    blocOffresMemorisees = $('.js-offres-memorisees'),
    btnMemorisees = $('.js-btn-memorisees'),
    btnPostulees = $('.js-btn-candidatees'),
    isDesktop = desktop.css('display') !== 'none',
    offresWithMatching = configuration.offresRecommandeesBulk,
    nbOffresBulk = offresWithMatching != null ? Object.keys(offresWithMatching).length : 0;

  const offresMemoriseesObj = {
    allOffresMemoriseesDesk: desktop.find(offreMemorisee),
    allOffresMemoriseesMob: mobile.find(offreMemorisee)
  };
  const offresCandidateesObj = {
    allOffresCandidateesDesk: desktop.find(offreCandidatee),
    allOffresCandidateesMob: mobile.find(offreCandidatee)
  };

  // Rendering des pies de completion du profil
  const notFullColor = isDesktop ? '#26aae1' : '#5adfb7';
  pieCompletion.render(
    $('.js-pie-completion-profil').attr('data-value'),
    '.js-pie-completion-profil',
    notFullColor,
    '#5adfb7'
  );

  if (configuration.doitAfficherModaleFinCreationProfil) {
    ga.sendNonInteractiveEvent(
      'inscription',
      'affichage_popin_confirmation_depot_cv',
      'sans_cv_upload'
    );
    $('.js-lightbox-fin-creation-profil-candidat')
      .remodal()
      .open();
  } else if (configuration.doitAfficherModaleMiseAJourProfil) {
    $('.js-lightbox-mise-a-jour-profil-candidat')
      .remodal()
      .open();
  } else if (configuration.doitAfficherModaleProfilComplet) {
    ga.sendNonInteractiveEvent(
      'inscription',
      'affichage_popin_confirmation_depot_cv',
      'avec_cv_upload'
    );
    $('.lightbox-dashboard-cv-complet').remodal().open();
  } else if (configuration.doitAfficherModaleDashboardPostuler) {
    const nbOffresMatching = getNbOffresMatching($('.remodal-checkbox:checkbox:checked'));
    $('.modal-dashboard-postuler-bulk').remodal().open();

    // Handler du click sur les checkbox customs
    $('span.checkmark').click(function() {
      let currentCheckmark = $(this); // La checkbox custom en cours sur laquelle on clique
      let currentCheckbox = $(`.checkbox-${currentCheckmark.attr('value')}`); // Repr�sente la checkbox associ�e � la checkmark

      if (currentCheckbox.prop('checked') === false) {
        currentCheckbox.prop('checked', true);
        $(`.offer-column-${currentCheckmark.attr('value')}`).toggleClass('selected');
      } else {
        currentCheckbox.prop('checked', false);
        $(`.offer-column-${currentCheckmark.attr('value')}`).toggleClass('selected');
      }
    });

    ga.sendNonInteractiveEvent(
      'inscription',
      'affichage_popin_candidature',
      `${nbOffresBulk}_offres_dont_${nbOffresMatching}_offres_matching`
    );

    $('#remodal-postule-click').click(function() {
      let offerIds = [];
      let offresChecked = $('.js-dashboard-checkbox:checked');
      let nbOffresMatchingSelectionnees = getNbOffresMatching(offresChecked);

      $('#remodal-postule-click')
        .prop('disabled', true)
        .addClass('disabled');

      offresChecked.each(function(i) {
        offerIds[i] = $(this).val();
      });

      if (offerIds.length > 0 && offerIds.length <= 3) {
        ga.sendEvent(
          'inscription',
          'clic_postuler_popin_candidature',
          `${offerIds.length}_offres_dont_${nbOffresMatchingSelectionnees}_offres_matching`
        );
        $.ajax({
          type: 'POST',
          url: '/emploi/publi/postuler_logge_bulk',
          contentType: 'application/json',
          dataType: 'json',
          data: JSON.stringify({
            offreIds: offerIds,
            provenance: 'massapply_majprofil_suggestion'
          })
        })
          .done(response => {
            $('#modale-reco-postuler-success').remodal().open();
            let notificationContent = '';
            let hasAppliedToSeveralOffers = response.offres.length > 1
            response.offres.forEach(function(offre) {
              let eventCategory = offre.isOffrePerf ? getCandidatureTrackingCategory(offre.source) : 'candidature';
              ga.sendEvent(eventCategory, 'candidature_1clic', offre.id);
              notificationContent += `<p>${offre.title}</p>`;
            });
            if (hasAppliedToSeveralOffers) {
              let linkMessage = 'G\u00E9rer mes candidatures';
              notificationContent += `<a href="/emploi/perso/accueil_candidatures?filtre=candidatures">${linkMessage}</a>`;
              Notification.success(response.message, false, notificationContent, hasAppliedToSeveralOffers);
            } else {
              let message = `Candidature prise en compte. <a href="/emploi/perso/accueil_candidatures?filtre=candidatures">Voir</a>`
              Notification.success(message, false, null, hasAppliedToSeveralOffers);
            }
          })
          .fail(() => {
            $('#modale-reco-postuler-error').remodal().open();
            Notification.failure(`Une erreur s'est produite !`, false);
          });
      } else {
        $('.modale-reco-postuler').remodal().close();
      }
    });

    $('#remodal-postule-later-click').click(function() {
      ga.sendEvent('inscription', 'clic_voir_plus_offres_popin', 'clic_voir_plus_offres_popin');
      $('#modale-reco-postuler')
        .remodal()
        .close();
    });

    $('.js-modale-reco-postuler-voir-annonce').click(function() {
      ga.sendEvent(
        'inscription',
        'clic_voir_offre_popin_candidature',
        getMatchingLabel($(this).attr('data-value'))
      );
    });

    $('.modale-reco-postuler-error-voir-annonce').click(function() {
      ga.sendEvent(
        'inscription',
        'clic_voir_offre_popin_candidature',
        getMatchingLabel($(this).attr('data-value'))
      );
    });

    $('.modale-reco-postuler-close').click(function() {
      ga.sendEvent(
        'inscription',
        'clic_fermeture_popin_candidature',
        'clic_fermeture_popin_candidature'
      );
    });

    $('.remodal-checkbox').change(function() {
      if ($('.remodal-checkbox:checkbox:checked').length > 0) {
        $('#remodal-postule-click')
          .prop('disabled', false)
          .removeClass('disabled');
      }
    });
  }

  function getNbOffresMatching(collection) {
    let nbOffresMatching = 0;
    collection.each(function() {
      if (offresWithMatching[$(this).val()]) {
        nbOffresMatching++;
      }
    });
    return nbOffresMatching;
  }

  function getMatchingLabel(id) {
    return offresWithMatching[id] ? 'matching' : 'sans_matching';
  }

  // Tracking GA popin profil candidat sans CV
  $('.js-btn-fin-creation-profil-candidat-completer-avec-cv').click(() => {
    ga.sendEvent(
      'inscription',
      'clic_completer_profil_avec_upload_popin_confirmation_depot_cv',
      'gestion_cv'
    );
  });

  $('.js-lien-fin-creation-profil-candidat-ajouter-plus-tard').click(() => {
    ga.sendEvent(
      'inscription',
      'clic_mon_profil_est_a_jour_popin_confirmation_depot_cv',
      'gestion_cv'
    );
  });

  $('.js-btn-fin-creation-profil-candidat-cross-close').click(() => {
    ga.sendEvent('inscription', 'clic_sur_croix_popin_confirmation_depot_cv', 'gestion_cv');
  });

  // Tracking GA popin profil candidat avec CV
  $('#js-modale-dashboard-cv-complet-cross-close').click(() => {
    ga.sendEvent('inscription', 'clic_sur_croix_popin_confirmation_depot_cv', 'avec_cv_upload');
  });

  $('#js-modale-dashboard-cv-complet-voir-offres').click(() => {
    ga.sendEvent('inscription', 'clic_voir_offres_popin_confirmation_depot_cv', 'avec_cv_upload');
  });

  $('#js-modale-dashboard-cv-complet-modifier-profil').click(() => {
    ga.sendEvent(
      'inscription',
      'clic_modifier_profil_popin_confirmation_depot_cv',
      'avec_cv_upload'
    );
  });

  btnMemorisees.click(function() {
    if (isDesktop) {
      btnMemorisees.addClass('focus');
      blocOffresMemorisees.show();
      btnPostulees.removeClass('focus');
      blocOffresCandidatees.hide();
    }

    /* Tracking */

    const offres = isDesktop
      ? offresMemoriseesObj.allOffresMemoriseesDesk
      : offresMemoriseesObj.allOffresMemoriseesMob;

    ga.sendNonInteractiveEvent(
      'navigation',
      'affichage_espace_perso_brique_offres_memorisees',
      offres.length
    );

    if (offres.length > 0) {
      offres.click(function() {
        let offreId = $(this).attr('data-offreId');
        ga.sendEvent('navigation', 'clic_espace_perso_brique_offres_memorisees', offreId);
      });

      $('.js-voir-plus-offres-memorisees').click(function() {
        ga.sendEvent(
          'navigation',
          'clic_espace_perso_brique_offres_memorisees_consulter',
          'clic_espace_perso_brique_offres_memorisees_voir_plus'
        );
      });
    } else {
      $('.js-empty-offres-memorisees').click(function() {
        ga.sendEvent(
          'navigation',
          'clic_espace_perso_brique_offres_memorisees_consulter',
          'clic_espace_perso_brique_offres_memorisees_consulter'
        );
      });
    }
  });

  btnPostulees.click(function() {
    if (isDesktop) {
      btnPostulees.addClass('focus');
      blocOffresCandidatees.show();
      btnMemorisees.removeClass('focus');
      blocOffresMemorisees.hide();
    }

    /* Tracking */

    const offres = isDesktop
      ? offresCandidateesObj.allOffresCandidateesDesk
      : offresCandidateesObj.allOffresCandidateesMob;

    ga.sendNonInteractiveEvent(
      'navigation',
      'affichage_espace_perso_brique_offres_postulees',
      offres.length
    );

    if (offres.length > 0) {
      offres.click(function() {
        let offreId = $(this).attr('data-value');
        ga.sendEvent('navigation', 'clic_espace_perso_brique_offres_postulees', offreId);
      });

      $('.js-voir-plus-offres-candidatees').click(function() {
        ga.sendEvent(
          'navigation',
          'clic_espace_perso_brique_offres_postulees_consulter',
          'clic_espace_perso_brique_offres_postulees_voir_plus'
        );
      });
    } else {
      $('.js-empty-offres-candidatees').click(function() {
        ga.sendEvent(
          'navigation',
          'clic_espace_perso_brique_offres_postulees_consulter',
          'clic_espace_perso_brique_offres_postulees_consulter'
        );
      });
    }
  });

  btnMemorisees.click();

  $('.js-btn-memorisees, .js-btn-candidatees').click(function() {
    let isBtnMemorisees = $(this).hasClass('memorisees');

    if (isBtnMemorisees && isDesktop) {
      blocOffresMemorisees.show();
      blocOffresCandidatees.hide();
    } else {
      blocOffresCandidatees.show();
      blocOffresCandidatees.css('display', 'flex');
      blocOffresMemorisees.hide();
    }
  });

  $('.js-rubrique-trigger').click(function() {
    let currentRubrique = $(this);
    let currentExpand = currentRubrique.parent().find('.js-expand-rubrique');
    currentRubrique.find('.icon-arrow-down-sign').toggleClass('toggled');
    currentExpand.slideToggle('slow');

    if (!isDesktop && currentRubrique.hasClass('js-offres-memo-trigger')) {
      $('.js-offres-candidatees').css('display', 'flex');
      $('.js-offres-memorisees').css('display', 'flex');
    }
  });

  $('.js-visibility-cv-toggle').click(function() {
    let visibilite = $(this).is(':checked');
    const blocCvthequeCvVisible = $('.js-visible-cvtheque');
    const blocCvthequeCvInvisible = $('.js-invisible-cvtheque');

    $.ajax({
      type: 'POST',
      url: '/emploi/perso/candidat/modifier_visibilite_cv',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify({
        visibilite: visibilite
      })
    })
      .done(function() {
        if (visibilite) {
          ga.sendEvent(
            'navigation',
            'clic_espace_perso_profil_visibilite_cv',
            'activez_visibilite_cv'
          );
          blocCvthequeCvVisible.removeClass('invisible');
          blocCvthequeCvInvisible.addClass('invisible');
        } else {
          ga.sendEvent(
            'navigation',
            'clic_espace_perso_profil_visibilite_cv',
            'desactivez_visibilite_cv'
          );
          blocCvthequeCvVisible.addClass('invisible');
          blocCvthequeCvInvisible.removeClass('invisible');
        }
        $('.js-visibility-cv-toggle').prop('checked', visibilite);
      })
      .fail(function(message) {});
  });

  // Tracking Services
  $('.js-service-trad').click(() => {
    ga.sendEvent('navigation', 'clic_espace_perso_services_partenaires', 'cours_de_langue');
  });

  $('.js-service-cv').click(() => {
    ga.sendEvent('navigation', 'clic_espace_perso_services_partenaires', 'service_cv');
  });

  function getMonCvLabel() {
    if (configuration.doitAfficherBlocCvAjouter) {
      return 'brique_cv_upload';
    } else if (configuration.doitAfficherBlocCvActualiser) {
      return 'brique_cv_update';
    } else if (configuration.doitAfficherBlocCvVoir) {
      return 'brique_cv_view';
    }
  }

  if (
    configuration.doitAfficherBlocCvAjouter ||
    configuration.doitAfficherBlocCvActualiser ||
    configuration.doitAfficherBlocCvVoir
  ) {
    ga.sendNonInteractiveEvent('navigation', 'affichage_espace_perso_brique_cv', getMonCvLabel());
    $('.js-mon-cv-modifier').click(() => {
      ga.sendEvent('navigation', 'clic_espace_perso_brique_cv', 'cv_modifier');
    });
    $('.js-mon-cv-cta, .js-mon-cv-link').click(function() {
      ga.sendEvent('navigation', 'clic_espace_perso_brique_cv', getMonCvLabel());
    });
  }

  function getMonProfilLabel() {
    if (configuration.doitAfficherBlocProfilCvComplet) {
      return 'profil_update';
    } else {
      return 'profil_completion';
    }
  }

  ga.sendNonInteractiveEvent('navigation', 'affichage_espace_perso_profil', getMonProfilLabel());
  $('.js-mon-profil-modifier').click(() => {
    ga.sendEvent('navigation', 'clic_espace_perso_profil', 'profil_modifier');
  });
  $('.js-mon-profil-cta, .js-mon-profil-link').click(() => {
    ga.sendEvent('navigation', 'clic_espace_perso_profil', getMonProfilLabel());
  });

  function getMesAlertesLabel() {
    if (configuration.doitAfficherBlocAlertesCreer) {
      return 'mes_alertes_creation';
    } else if (configuration.doitAfficherBlocAlertesSansResultat) {
      return 'mes_alertes_update';
    } else if (configuration.doitAfficherBlocAlertesActives) {
      return 'mes_alertes_view';
    }
  }

  if (
    configuration.doitAfficherBlocAlertesCreer ||
    configuration.doitAfficherBlocAlertesSansResultat ||
    configuration.doitAfficherBlocAlertesActives
  ) {
    ga.sendNonInteractiveEvent(
      'navigation',
      'affichage_espace_perso_alertes',
      getMesAlertesLabel()
    );
    $('.js-mes-alertes-modifier').click(() => {
      ga.sendEvent('navigation', 'clic_espace_perso_alertes', 'alertes_modifier');
    });
    $('.js-mes-alertes-cta, .js-mes-alertes-link').click(function() {
      ga.sendEvent('navigation', 'clic_espace_perso_alertes', getMesAlertesLabel());
    });
  }

  if (configuration.doitAfficherBlocProfilCvComplet) {
    if (configuration.doitAfficherBlocCvThequeToggleOn) {
      ga.sendNonInteractiveEvent(
        'navigation',
        'affichage_espace_perso_profil_visibilite_cv',
        'visibilite_active'
      );
    } else {
      ga.sendNonInteractiveEvent(
        'navigation',
        'affichage_espace_perso_profil_visibilite_cv',
        'visibilite_desactive'
      );
    }
  }

  // Suppression profil
  const isProfilReinitialise = configuration.isReinitialisationProfilSucces;
  if (isProfilReinitialise !== undefined && isProfilReinitialise !== null) {
    let currentToaster = $('.js-toaster');
    let successClass = isProfilReinitialise ? 'success' : 'error';
    let displayText = isProfilReinitialise
      ? `Votre profil a bien &eacute;t&eacute; r&eacute;initialis&eacute; !`
      : `Une erreur est survenue, veuillez r&eacute;essayer plus tard.`;

    currentToaster.addClass(successClass);
    $('.js-toaster-text').append(displayText);

    $('.js-close-toaster').click(() => currentToaster.remove());
    currentToaster.fadeIn('slow');

    let timeOutId = setTimeout(() => {
      currentToaster.fadeOut('fast', () => currentToaster.remove());
      clearTimeout(timeOutId);
    }, 5000);
  }

  $('#js-supprimer-profil-btn').click(() => {
    ga.sendEvent('temporaire', 'reinitialisation_profil', 'clic_reinitialisation_profil');
    $('#lightbox-suppression-profil-candidat')
      .remodal()
      .open();
  });

  $('.js-modal-suppression-confirmation').click(function() {
    ga.sendEvent('temporaire', 'reinitialisation_profil', 'clic_confirmer_reinitialisation_profil');
    $(this)
      .find('form')
      .submit();
  });

  $('.js-modal-suppression-close, .js-icon-cross-close').click(function() {
    ga.sendEvent('temporaire', 'reinitialisation_profil', 'clic_annuler_reinitialisation_profil');
    $('#lightbox-suppression-profil-candidat')
      .remodal()
      .close();
  });
}

function trackingItemsAccesRapide() {
  $('.js-recherche-acces-rapide').click(function() {
    ga.sendEvent(
      'navigation',
      'clic_espace_perso_menu_bouton_recherche',
      'clic_espace_perso_menu_bouton_recherche'
    );
  });

  $('.js-alertes-acces-rapide').click(function() {
    ga.sendEvent('navigation', 'clic_espace_perso_menu_alertes', 'clic_espace_perso_menu_alertes');
  });

  $('.js-dashboard-acces-rapide').click(function() {
    ga.sendEvent('navigation', 'clic_espace_perso_menu_dashboard', 'clic_espace_perso_menu_dashboard');
  });

  $('.js-mon-cv-acces-rapide').click(function() {
    ga.sendEvent('navigation', 'clic_espace_perso_menu_cv', 'clic_espace_perso_menu_cv');
  });

  $('.js-offres-memo-acces-rapide').click(function() {
    ga.sendEvent(
      'navigation',
      'clic_espace_perso_menu_offres_memorisees',
      'clic_espace_perso_menu_offres_memorisees'
    );
  });

  $('.js-offres-candidatees-acces-rapide').click(function() {
    ga.sendEvent(
      'navigation',
      'clic_espace_perso_menu_candidatures',
      'clic_espace_perso_menu_candidatures'
    );
  });

  $('.js-lettre-de-motiv-acces-rapide').click(function() {
    ga.sendEvent('navigation', 'clic_espace_perso_menu_lettres', 'clic_espace_perso_menu_lettres');
  });

  $('.js-mon-compte-acces-rapide').click(function() {
    ga.sendEvent(
      'navigation',
      'clic_espace_perso_menu_mon_compte',
      'clic_espace_perso_menu_mon_compte'
    );
  });

  $('.js-deconnexion-acces-rapide').click(function() {
    $('.js-modal-deconnexion-cancel-link').click(function() {
      ga.sendEvent('navigation', 'clic_espace_perso_menu_deconnecte', 'annule_deconnecte');
    });

    $('.js-modal-deconnexion-button').click(function() {
      ga.sendEvent('navigation', 'clic_espace_perso_menu_deconnecte', 'valide_deconnecte');
    });
  });
}

function trackerFilAriane(page) {
  const lien = $('.js-lien-file-ariane');

  if (lien) {
    ga.sendNonInteractiveEvent('navigation', 'affichage_espace_perso_fil_ariane', page);
    lien.click(function() {
      ga.sendEvent('navigation', 'clic_espace_perso_fil_ariane', 'espace_candidat');
    });
  }
}

function trackerCreationCompteViaSocialConnect(configuration) {
  if (configuration.accountCreationWithSocialConnectProvider) {
    let value = 'creation_compte';
    if (configuration.accountCreationWithSocialConnectProvider === 'google')
      value = 'via_page_inscription_Google';
    else if (configuration.accountCreationWithSocialConnectProvider === 'facebook')
      value = 'via_page_inscription_Facebook';
    ga.sendNonInteractiveEvent('creation_compte', 'creation_compte', value);
  }
}

function lightboxDeconnexion() {
  $('.js-deconnexion-espace-perso').click(function() {
    $('#lightbox-deconnexion-espace-perso')
      .remodal()
      .open();
  });

  $('.js-modal-deconnexion-cancel-link, .js-icon-cross-close').click(function() {
    $('#lightbox-deconnexion-espace-perso')
      .remodal()
      .close();
  });

  $('.js-modal-deconnexion-button').click(function() {
    $(this)
      .find('form')
      .submit();
  });
}

function postulerAuxOffresRecommandees(configuration, page) {
  const gaLabel = page === 'DASHBOARD' ? 'espace_perso' : 'detail_candidature';

  if (configuration.doitAfficherPostuler1Click) {
    ga.sendNonInteractiveEvent(
        'navigation',
        configuration.isOffreReco
            ? `affichage_${gaLabel}_offres_reco_postuler_1_clic`
            : `affichage_${gaLabel}_offres_du_jour_postuler_1_clic`,
        configuration.nbOffresSuggerees
    );
  } else {
    ga.sendNonInteractiveEvent(
        'navigation',
        configuration.isOffreReco
            ? `affichage_${gaLabel}_offres_reco`
            : `affichage_${gaLabel}_offres_du_jour`,
        configuration.nbOffresSuggerees
    );
  }

  // tracking GA sur le titre de l'offre
  $('.js-tracking-detail-offre-reco-titre-offre').click(function() {
    const offreId = $(this).attr('data-offreId');
    if (offreId !== '') {
      ga.sendEvent('navigation', `clic_offre_reco_${gaLabel}`, offreId);
    }
  });

  // tracking GA sur le lien "voir annonce"
  $('.js-tracking-detail-offre-reco-voir-annonce').click(function() {
    const offreId = $(this).attr('data-offreId');
    if (offreId !== '') {
      ga.sendEvent('navigation', `clic_voir_annonce_reco_${gaLabel}`, offreId);
    }
  });

  $('.js-postuler-1-clic, .js-postuler-retry').click(function() {
    const currentButton = $(this);
    const offreId = currentButton.parent().attr('data-offreId');
    const provenance = currentButton.parent().attr('data-provenance');
    if (offreId !== '') {
      ga.sendEvent('navigation', `clic_postuler_1clic_confirmation_${gaLabel}`, offreId);
    }

    confirmerCandidature1Clic(() => {
      $(`.btn-content-${offreId}`).hide();
      $(`.js-loader-${offreId}`).show();

      $.ajax({
        type: 'POST',
        url: '/emploi/publi/postuler_logge_bulk',
        data: JSON.stringify({
          offreIds: [offreId],
          provenance: provenance
        }),
        contentType: 'application/json',
        dataType: 'json'
      })
          .done(response => {
            currentButton.fadeOut(500, () => $(`.sent-${offreId}`).fadeIn(500));

            let notificationContent = '';
            let hasAppliedToSeveralOffers = response.offres.length > 1
            response.offres.forEach(function(offre) {
              ga.sendEvent(
                  offre.isOffrePerf ? 'candidature_offre_perf' : 'candidature',
                  configuration.isOffreReco
                      ? `candidature_1clic_${gaLabel}_reco`
                      : `candidature_1clic_${gaLabel}_du_jour`,
                  offreId
              );
              notificationContent += `<p>${offre.title}</p>`;
            });
            if (hasAppliedToSeveralOffers) {
              let linkMessage = 'G\u00E9rer mes candidatures';
              notificationContent += `<a href="/emploi/perso/accueil_candidatures?filtre=candidatures">${linkMessage}</a>`;
              Notification.success(response.message, false, notificationContent, hasAppliedToSeveralOffers);
            } else {
              let message = `Candidature prise en compte. <a href="/emploi/perso/accueil_candidatures?filtre=candidatures">Voir</a>`
              Notification.success(message, false, null, hasAppliedToSeveralOffers);
            }
          })
          .fail(() => {
            currentButton.fadeOut(500, () => $(`.retry-${offreId}`).fadeIn(500));
            Notification.failure(`Une erreur s'est produite !`, false);
          });
    }, page);
  });
}

export default dashboardEspacePerso;
export {
  trackingItemsAccesRapide,
  trackerCreationCompteViaSocialConnect,
  trackerFilAriane,
  lightboxDeconnexion,
  postulerAuxOffresRecommandees
};
